import React from 'react'

const Camera = () => {
    return (
        <>
            <div>
                {/* <h2>Live Camera Feed</h2> */}
                <iframe
                    src="https://cam.vechnology.com.my"
                    width="100%"
                    height="480"
                    style={{ border: "1px solid #ccc" }}
                    allowFullScreen
                    title="Camera Stream"
                ></iframe>
            </div>
        </>
    );
}

export default Camera;
